import ClueFragments from './ClueFragments';

export default ClueFragments;